<script setup lang="ts">
import {Model} from "@/app/Model";
import {Comms} from "@/app/Comms";
let model: Model = Model.getReactiveInstance();
let comms: Comms = Comms.getInstance();

function handleSubmit(): void {
  if (model.pen_admin.itemPenale.id_localita == null || model.pen_admin.itemPenale.id_localita == "") {
    alert ("Località obbligatorio!")
    return;
  }
  //if (model.pen_admin.itemPenale.durata_del_processo == null || model.pen_admin.itemPenale.durata_del_processo == 0) {
  //  alert ("Durata del processo obbligatorio!")
  //  return;
  //}
  if (model.pen_admin.itemPenale.assoluzione == null || model.pen_admin.itemPenale.assoluzione == "") {
    alert ("Assoluzione Esito obbligatorio!")
    return;
  }
  assignStatus();

  model.pen_admin.itemPenale.modifica_manuale = true;
  comms.penaleAdmin.chiamataPenaleSave( ()=> {} )
}

function addAssoluzioneMotivo(): void {
  model.pen_admin.itemPenale.assoluzione_motivo?.push('');
}

function removeAssoluzioneMotivo(index: number): void {
  model.pen_admin.itemPenale.assoluzione_motivo?.splice(index, 1);
}

function addCapoImputazioneLegge(): void {
  model.pen_admin.itemPenale.capo_imputazione_legge?.push('');
}

function removeCapoImputazioneLegge(index: number): void {
  model.pen_admin.itemPenale.capo_imputazione_legge?.splice(index, 1);
}

function addDurataPena(): void {
  model.pen_admin.itemPenale.durata_pena?.push(0);
}

function removeDurataPena(index: number): void {
  model.pen_admin.itemPenale.durata_pena?.splice(index, 1);
}

function addGiudice(): void {
  model.pen_admin.itemPenale.giudice?.push('');
}

function removeGiudice(index: number): void {
  model.pen_admin.itemPenale.giudice?.splice(index, 1);
}

function addPenaPrincipale(): void {
  model.pen_admin.itemPenale.pena_principale?.push('');
}

function removePenaPrincipale(index: number): void {
  model.pen_admin.itemPenale.pena_principale?.splice(index, 1);
}

function addCapoImputazioneLeggeParziale(): void {
  model.pen_admin.itemPenale.capo_imputazione_legge_parziale?.push('');
}

function removeCapoImputazioneLeggeParziale(index: number): void {
  model.pen_admin.itemPenale.capo_imputazione_legge_parziale?.splice(index, 1);
}

function addCapoImputazioneLeggeOriginale(): void {
  model.pen_admin.itemPenale.capo_imputazione_legge_originale?.push('');
}

function removeCapoImputazioneLeggeOriginale(index: number): void {
  model.pen_admin.itemPenale.capo_imputazione_legge_originale?.splice(index, 1);
}


function assignStatus(): void {
  if (model.pen_admin.itemPenale.durata_del_processo == null)
  {
    model.pen_admin.itemPenale.id_stato_sen = 2;
  }
  else if (model.pen_admin.itemPenale.capo_imputazione_legge == null)
  {
    model.pen_admin.itemPenale.id_stato_sen = 3;
  }
  else if(model.pen_admin.itemPenale.durata_pena != null && model.pen_admin.itemPenale.pena_principale == null)
  {
    model.pen_admin.itemPenale.id_stato_sen = 4;
  }
  else
  {
    model.pen_admin.itemPenale.id_stato_sen = 1;
  }
}
</script>


<template>
  <div class="modal fade" id="ModalAdminPenaleItem" tabindex="-1" aria-labelledby="labelModalAdminPenaleItem"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="labelModalAdminPenaleItem">Modifica
              {{ model.pen_admin.itemPenale.id_doc_master }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <div class="mb-3 not-visible">
              <label for="idDocMaster" class="form-label">ID Doc Master</label>
              <input type="number" class="form-control" id="idDocMaster"
                     v-model.number="model.pen_admin.itemPenale.id_doc_master">
            </div>
            <div class="mb-3 not-visible">
              <label for="id_stato_sen" class="form-label">Stato Sentenza</label>
              <input type="number" class="form-control" id="id_stato_sen"
                     v-model.number="model.pen_admin.itemPenale.id_stato_sen">
            </div>
            <div class="mb-3">
              <label for="assoluzione" class="form-label">Assoluzione Esito</label>
              <select class="form-select" id="assoluzione" v-model="model.pen_admin.itemPenale.assoluzione">
                <option value="">Scegli...</option>
                <option v-for="(item, index) in Model.lista_esito_del_processo" :value="item" :key="'esito_'+item">{{ Model.lista_esito_del_processo_labels[index] }}</option>
              </select>
            </div>
            <!-- Modifica, Aggiunta e Rimozione per assoluzione_motivo -->
            <div class="mb-3">
              <label for="assoluzioneMotivo" class="form-label">Assoluzione Motivo</label><br>
              <div v-for="(motivo, index) in model.pen_admin.itemPenale.assoluzione_motivo" :key="index"
                   class="input-group mb-1">
                <input type="text" class="form-control" placeholder="Inserisci motivo assoluzione"
                       v-model="model.pen_admin.itemPenale.assoluzione_motivo[index]">
                <button type="button" class="btn btn-danger" @click="removeAssoluzioneMotivo(index)">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addAssoluzioneMotivo"
                      v-if="model.pen_admin.itemPenale.assoluzione_motivo[model.pen_admin.itemPenale.assoluzione_motivo.length-1] != ''">Aggiungi Assoluzione Motivo</button>
            </div>
            <!-- Modifica, Aggiunta e Rimozione per capo_imputazione_legge -->
            <div class="mb-3">
              <label for="capoImputazioneLegge" class="form-label">Capo Imputazione</label><br>
              <div v-for="(legge, index) in model.pen_admin.itemPenale.capo_imputazione_legge" :key="index"
                   class="input-group mb-1">
                <input type="text" class="form-control" placeholder="Inserisci capo imputazione"
                       v-model="model.pen_admin.itemPenale.capo_imputazione_legge[index]">
                <button type="button" class="btn btn-danger" @click="removeCapoImputazioneLegge(index)"
                        v-if="model.pen_admin.itemPenale.capo_imputazione_legge[model.pen_admin.itemPenale.capo_imputazione_legge.length-1] != ''">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addCapoImputazioneLegge">Aggiungi Capo Imputazione</button>
            </div>
            <div class="mb-3 not-visible">
              <label for="idLocalita" class="form-label">Località</label>
              <select class="form-select" id="idLocalita" v-model="model.pen_admin.itemPenale.id_localita">
                <option value="">Scegli...</option>
                <option v-for="(item, index) in model.pen_lista_citta" :value="item.id_localita" :key="'citta_'+item.id_localita">{{ item.citta }}</option>
              </select>

            </div>
            <div class="mb-3 not-visible">
              <label for="dataPronunciaSentenza" class="form-label">Data Pronuncia</label>
              <input type="date" class="form-control" id="dataPronunciaSentenza"
                     v-model="model.pen_admin.itemPenale.data_pronuncia_sentenza">
            </div>
            <div class="mb-3">
              <label for="durataDelProcesso" class="form-label">Durata Processo</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="durataDelProcesso" min="0"
                     v-model.number="model.pen_admin.itemPenale.durata_del_processo">
            </div>
            <!-- Modifica, Aggiunta e Rimozione per durata_pena -->
            <div class="mb-3">
              <label for="durataPena" class="form-label">Durata Pena</label><br>
              <div v-for="(pena, index) in model.pen_admin.itemPenale.durata_pena" :key="index"
                   class="input-group mb-1">
                <input type="number" class="form-control" min="0"
                       v-model.number="model.pen_admin.itemPenale.durata_pena[index]">
                <button type="button" class="btn btn-danger" @click="removeDurataPena(index)">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addDurataPena">Aggiungi Durata Pena</button>
            </div>
            <!-- Modifica, Aggiunta e Rimozione per giudice -->
            <div class="mb-3">
              <label for="giudice" class="form-label">Giudice</label><br>
              <div v-for="(giudice, index) in model.pen_admin.itemPenale.giudice" :key="index" class="input-group mb-1">
                <input type="text" class="form-control" v-model="model.pen_admin.itemPenale.giudice[index]" placeholder="Inserisci giudice">
                <button type="button" class="btn btn-danger" @click="removeGiudice(index)">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addGiudice"
                      v-if="model.pen_admin.itemPenale.giudice[model.pen_admin.itemPenale.giudice.length-1] != ''">Aggiungi Giudice</button>
            </div>
            <div class="mb-3">
              <label for="importoEvaso" class="form-label">Importo Evaso</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="importoEvaso"
                     v-model.number="model.pen_admin.itemPenale.importo_evaso" step="0.01">
            </div>
            <div class="mb-3">
              <label for="importoRisarcimento" class="form-label">Importo Risarcimento</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="importoRisarcimento"
                     v-model.number="model.pen_admin.itemPenale.importo_risarcimento" step="0.01">
            </div>
            <!-- Modifica, Aggiunta e Rimozione per pena_principale -->
            <div class="mb-3">
              <label for="penaPrincipale" class="form-label">Pena Principale</label><br>
              <div v-for="(pena, index) in model.pen_admin.itemPenale.pena_principale" :key="index"
                   class="input-group mb-1">
                <input type="text" class="form-control" v-model="model.pen_admin.itemPenale.pena_principale[index]" placeholder="Inserisci pena principale">
                <button type="button" class="btn btn-danger" @click="removePenaPrincipale(index)">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addPenaPrincipale"
                      v-if="model.pen_admin.itemPenale.pena_principale[model.pen_admin.itemPenale.pena_principale.length-1] != ''">Aggiungi Pena Principale</button>
            </div>
            <div class="mb-3">
              <input type="checkbox" class="form-check-input" id="nonMenzioneNelCasellario"
                     v-model="model.pen_admin.itemPenale.non_menzione_nel_casellario">
              <label class="form-check-label" for="nonMenzioneNelCasellario"> &nbsp;Non Menzione nel Casellario</label>
            </div>
            <div class="mb-3 not-visible">
              <label for="data" class="form-label">Data Sentenza</label>
              <input type="date" class="form-control" id="data" v-model="model.pen_admin.itemPenale.data">
            </div>
            <!-- Modifica, Aggiunta e Rimozione per capo_imputazione_legge_parziale -->
            <div class="mb-3 not-visible">
              <label for="capoImputazioneLeggeParziale" class="form-label">Capo Imputazione Legge Parziale</label><br>
              <div v-for="(legge, index) in model.pen_admin.itemPenale.capo_imputazione_legge_parziale" :key="index"
                   class="input-group mb-1">
                <input type="text" class="form-control"
                       v-model="model.pen_admin.itemPenale.capo_imputazione_legge_parziale[index]">
                <button type="button" class="btn btn-danger" @click="removeCapoImputazioneLeggeParziale(index)">
                  Rimuovi
                </button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addCapoImputazioneLeggeParziale">Aggiungi Legge
                Parziale
              </button>
            </div>
            <!-- Modifica, Aggiunta e Rimozione per capo_imputazione_legge_originale -->
            <div class="mb-3 not-visible">
              <label for="capoImputazioneLeggeOriginale" class="form-label">Capo Imputazione Legge Originale</label><br>
              <div v-for="(legge, index) in model.pen_admin.itemPenale.capo_imputazione_legge_originale" :key="index"
                   class="input-group mb-1">
                <input type="text" class="form-control"
                       v-model="model.pen_admin.itemPenale.capo_imputazione_legge_originale[index]">
                <button type="button" class="btn btn-danger" @click="removeCapoImputazioneLeggeOriginale(index)">
                  Rimuovi
                </button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addCapoImputazioneLeggeOriginale">Aggiungi Legge
                Originale
              </button>
            </div>
            <div class="mb-3 not-visible">
              <label for="dataElaborazione" class="form-label">Data Elaborazione</label>
              <input type="date" class="form-control" id="dataElaborazione"
                     v-model="model.pen_admin.itemPenale.data_elaborazione">
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="handleSubmit()" :disabled="comms.penaleAdmin.inChiamataPenaleSave">Salva</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>